<template>
<div class="workshop-item" data-cont="small">
  <div class="ws-item__image">
    <h4 class="ws-item__subtitle u-hidden--from-mobileL" v-html="data.date" js-anim="text"></h4>
    <h3 class="ws-item__title u-hidden--from-mobileL" v-html="data.workshopTitle" js-anim="title"></h3>

    <BaseButtonFilled class="ws-item__button u-hidden--from-mobileL" :data="data" v-if="data.content !== ''" />

    <BasePicture
      class="image__picture"
      :data="Object.assign(data, { tagImg: false })"/>
  </div>
  <div class="ws-item__content">
    <BaseButtonFilled class="ws-item__button u-hidden--until-mobileL" :data="data" v-if="data.content !== ''" />

    <h4 class="ws-item__subtitle u-hidden--until-mobileL" v-html="data.date" js-anim="text"></h4>
    <h3 class="ws-item__title u-hidden--until-mobileL" v-html="data.workshopTitle" js-anim="title"></h3>
    <h5 class="ws-item__info" v-html="data.descriptionInfo" js-anim="text"></h5>
    <p
      class="ws-item__text"
      v-html="data.description"
      js-anim="text"
    ></p>
    <ul
      class="ws-item__list"
      js-anim="text"
      v-if="data.list && (Object.keys(data.list).length > 0 || data.list.length > 0)"
    >
      <li><strong>{{ data.listTitle }}</strong></li>
      <li
        :class="['list__item', index === 0 ? 'list__item--first': false]"
        v-for="(item, index) in sortedList"
        :key="Math.random() + index"
      >
        <strong>{{ item.time }}</strong>
        <span> - </span>
        <span>{{ item.text }}</span>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import BasePicture from '@/components/BasePicture';
import BaseButtonFilled from '@/components/BaseButtonFilled';
import { sortObject } from '@/scripts/utils';


export default {
  name: 'baseBigBlock',

  components: {
    BasePicture,
    BaseButtonFilled,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sortedList() {
      return sortObject(this.data.list, 'order');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.workshop-item {
  position: relative;
  width: 100%;
  padding: 30px 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-flow: row wrap;

  &:first-child {
    padding: 0 0 30px;
  }

  @include mq(mobileL) {
    padding: 80px 0;

    &:first-child {
      padding: 0 0 80px;
    }
  }

  > div {
    display: inline-block;
  }

  .ws-item {
    display: inline-block;

    &__image {
      width: 100%;
      flex: 0 0 100%;

      @include mq(mobileL) {
        width: 34%;
        flex: 0 0 34%;
      }

      .image__picture {
        width: 100%;
        margin-bottom: 140px;

        @include aspect-ratio(1, 1.1);
      }

      button {
        // margin-top: 40px;
      }
    }

    &__content {
      position: relative;
      width: 100%;
      flex: 0 0 100%;

      padding: 0 20px;

      @include mq(mobileL) {
        padding: 0;
        width: calc(66% - 80px);
        flex: 0 0 66%;
        flex-basis: calc(66% - 80px);
      }
    }

    &__title {
      margin-bottom: 20px;

      @include mq($until: ipadP) {
        font-size: 2rem;
      }

      @include mq(ipadP) {
        margin-bottom: 0;
        margin-top: 40px;
      }
    }

    &__info {
      font-size: 1.2rem;

      margin: 40px 0 20px;

      @include mq(mobileL) {
        margin: 40px 0 60px;
      }
    }

    &__subtitle {
      margin-bottom: 20px;

      letter-spacing: 2px;
      font-size: font-size(s);
      font-weight: 400;
      text-transform: uppercase;

      @include mq(mobileL) {
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }

    &__button {
      position: relative;
      margin-bottom: 40px;
      left: -20px;

      @include mq(mobileL) {
        display: inline-block;
        position: absolute;
        right: 0;
        left: auto;
        top: -2px;
        margin-bottom: 0px;
      }
    }

    &__text {
      margin-bottom: 30px;
    }

    &__list {
      margin-bottom: 30px;
      line-height: 1.8;

      .list__item--first {
        font-weight: 700;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
